"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAfterTransactionEvents = fetchAfterTransactionEvents;
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
const client_js_1 = require("../client.js");
const constants_js_1 = require("../../common/constants.js");
const coins_js_1 = require("../../common/coins.js");
async function fetchAfterTransactionEvents(params) {
    const eventTypesSet = new Set();
    if (params.poolNames) {
        params.poolNames.forEach((poolName) => {
            const eventType = maps_js_1.poolInfo[poolName].afterTransactionEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    else {
        // Iterate over all the values in poolInfo and add each autoCompoundingEventType to the Set
        Object.values(maps_js_1.poolInfo).forEach((info) => {
            const eventType = info.afterTransactionEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    const eventTypes = Array.from(eventTypesSet);
    const eventsPromises = eventTypes.map(async (eventType) => {
        const events = await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        });
        return events;
    });
    const events = (await Promise.all(eventsPromises)).flat();
    const afterTransactionEvents = events.map((e) => {
        return e;
    });
    if (params.poolNames &&
        params.poolNames.length === 1 &&
        params.poolNames[0] === "ALPHA") {
        return afterTransactionEvents;
    }
    const afterTransactionEventsWithPool = await (async () => {
        const txDigests = [];
        for (const event of afterTransactionEvents) {
            if (!event.poolName) {
                txDigests.push(event.id.txDigest);
            }
        }
        const suiClient = (0, client_js_1.getSuiClient)();
        let eventsFromTx = [];
        while (txDigests.length > 0) {
            const batch = txDigests.splice(0, Math.min(50, txDigests.length));
            const eventsFromTxBatch = await suiClient.multiGetTransactionBlocks({
                digests: batch,
                options: { showEvents: true },
            });
            eventsFromTx = eventsFromTx.concat(eventsFromTxBatch);
        }
        return new Map(eventsFromTx.map((txData) => {
            return [txData.digest, txData];
        }));
    })();
    for (let i = 0; i < afterTransactionEvents.length; i++) {
        const event = afterTransactionEvents[i];
        if (event.poolName)
            continue;
        const otherEvents = afterTransactionEventsWithPool.get(event.id.txDigest)?.events;
        if (!otherEvents) {
            throw new Error(`SuiTransactionBlockResponse not found for digest: ${event.id.txDigest}`);
        }
        const thisPoolName = ((otherEvents) => {
            for (let j = 0; j < otherEvents.length; j++) {
                const otherEvent = otherEvents[j];
                if (otherEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].CETUS_ADD_LIQUIDITY_EVENT ||
                    otherEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].CETUS_REMOVE_LIQUIDITY_EVENT) {
                    //CETUS
                    const eventJson = otherEvent.parsedJson;
                    const cetusPoolId = eventJson.pool;
                    const poolName = Object.keys(maps_js_1.parentPoolMap).find((pool) => maps_js_1.parentPoolMap[pool] === cetusPoolId);
                    if (!poolName)
                        throw new Error(`cetusPoolName not found for event: ${otherEvent}`);
                    return poolName;
                }
                else if (otherEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].NAVI_POOL_DEPOSIT_EVENT ||
                    otherEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].NAVI_POOL_WITHDRAW_EVENT) {
                    //NAVI
                    const eventJson = otherEvent.parsedJson;
                    const naviCoinId = eventJson.pool ===
                        "0000000000000000000000000000000000000000000000000000000000000002::sui::SUI"
                        ? "0x2::sui::SUI"
                        : `0x${eventJson.pool}`;
                    const coinName = Object.keys(coins_js_1.coinsList).find((coin) => coins_js_1.coinsList[coin].type === naviCoinId);
                    const poolName = Object.keys(maps_js_1.singleAssetPoolCoinMap).find((pool) => maps_js_1.singleAssetPoolCoinMap[pool].coin === coinName);
                    if (!poolName) {
                        console.error("for event: ", otherEvent);
                        throw new Error(`naviPoolName not found`);
                    }
                    return poolName;
                }
                else {
                    if (j === otherEvents.length - 1) {
                        console.error("digest", event.id.txDigest);
                        throw new Error("deposit/withdraw events not found for either CETUS, or NAVI");
                    }
                }
            }
        })(otherEvents);
        if (!thisPoolName)
            throw new Error(`PoolName not found`);
        const eventWithPool = {
            ...event,
            poolName: thisPoolName,
        };
        afterTransactionEvents[i] = eventWithPool;
    }
    if (params.poolNames && params.poolNames.length >= 1) {
        const allowedPoolNames = params.poolNames;
        return afterTransactionEvents.filter((event) => allowedPoolNames.includes(event.poolName));
    }
    return afterTransactionEvents;
}
//# sourceMappingURL=fetchAfterTransactionEvents.js.map